export default Object.freeze({
  loading: false,
  error: null,
  categories: [],
  formSent: false,
  showSuccess: false,
});
